
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {CertificateModel} from "@/api-client";
    import {Prop} from "vue-property-decorator";

    @Component
    export default class Certificate extends Vue {
        @Prop({required: true})
        document!: CertificateModel;
    }
